import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import axios from "axios";
import { Message } from "element-ui";
import { getToken } from "@/utils/auth";
import { TIMEZONES } from "@/utils/timezone";
import Vue from "vue";
import router from "@/router/index";
// eslint-disable-next-line import/no-cycle
import store from "@/store/index";
const isSsoUserInfoEmpty = () => {
  const ssoUserInfo = {
    ...store.getters.userInfo.sso_user_info
  };
  if (!ssoUserInfo) return true;
  if (typeof ssoUserInfo !== "object") return true;
  return Object.keys(ssoUserInfo).length === 0;
};
const removeEmptyProps = obj => {
  if (obj) {
    const newObj = Array.isArray(obj) ? [] : {};
    Object.keys(obj).forEach(key => {
      if (obj[key] && typeof obj[key] === "object") {
        newObj[key] = removeEmptyProps(obj[key]); // recurse
      } else if (obj[key] != null) {
        // include undefined
        newObj[key] = obj[key]; // copy value
      }
    });
    return newObj;
  }
  return obj;
};
const loginTimeOut = () => {
  const ssoUrl = Vue.prototype.$appOssUrl || process.env.VUE_APP_OSS_URL;
  const bindOss = !isSsoUserInfoEmpty();
  if (!bindOss) {
    store.dispatch("user/logout").then(() => {
      router.push({
        path: "/login"
      }).catch(() => {});
    });
    return;
  }
  if (ssoUrl) {
    try {
      store.dispatch("user/logout").then(() => {
        window.location.href = ssoUrl;
      });
    } catch (err) {
      console.error(err);
      store.dispatch("user/logout").then(() => {
        router.push({
          path: "/login"
        }).catch(() => {});
      });
    }
  } else {
    store.dispatch("user/logout").then(() => {
      router.push({
        path: "/login"
      }).catch(() => {});
    });
  }
};
const getErrorMessage = (data, fallback = "Error") => {
  if (data && data.error && data.error.error_message) {
    return data.error.error_message;
  }
  if (data && data.error_message) {
    return data.error_message;
  }
  if (data && data.message) {
    return data.message;
  }
  return fallback;
};

// create an axios instance
const service = axios.create({
  baseURL: Vue.prototype.$appBaseApi || process.env.VUE_APP_BASE_API,
  timeout: 30000,
  // request timeout
  withCredentials: true,
  transformRequest: [data => removeEmptyProps(data), ...axios.defaults.transformRequest]
});
// request interceptor
service.interceptors.request.use(config => {
  const configClone = config;
  configClone.headers.Authorization = `daren ${getToken()}`;
  configClone.headers.TZ = TIMEZONES[window.vue.$store.getters.timezone].value;
  if (configClone.params) {
    Object.keys(configClone.params).forEach(k => {
      if (typeof configClone.params[k] === "string") {
        configClone.params[k] = configClone.params[k].trim();
      }
    });
  }
  return configClone;
}, error => {
  Promise.reject(error);
});

// response interceptor
service.interceptors.response.use(response => {
  const res = response.data;
  if (res.code !== 0) {
    const error = getErrorMessage(res);
    Message({
      message: error,
      type: "error",
      duration: 3 * 1000,
      center: true
    });
  } else if (res.code === 401) {
    loginTimeOut();
  }
  return res;
}, error => {
  const {
    response
  } = error;
  const responseData = response && response.data;
  if (response && response.status === 401) {
    // Message({
    //   message: 'login expired',
    //   type: 'warning',
    //   duration: 2 * 1000,
    // });

    loginTimeOut();
    return Promise.reject(responseData);
  }
  // console.log(`err${res.code}`); // for debug
  const message = getErrorMessage(responseData, error.message);
  error.message = message;
  Message({
    message,
    type: "error",
    duration: 3 * 1000,
    center: true
  });
  return Promise.reject(error);
});
export default service;